<template>
  <HomeLayout>
    <b-row class="column-border-container">
      <b-col class="column-border col-lg card-col col-12">
        <div
          @click="openVouchersAndDocsModal"
          class="vtd-card vtd-animate-shake"
        >
          <div class="navigation-block">
            <h4 class="nav-title-center">VOUCHERS</h4>
            <div class="nav-text-center">
              <i class="icon-vouchers vtd-icon-7" />
            </div>
          </div>
          <VoucherAndDocsModal ref="VoucherAndDocRef" />
          <div class="vtd-card-footer nav-text-center d-none d-lg-block">
            <p class="vtd-home-btn text-center">View Now</p>
          </div>
        </div>
      </b-col>

      <b-col class="column-border col-lg card-col col-12">
        <div @click="openETicketsModal" class="vtd-card vtd-animate-shake">
          <div class="navigation-block">
            <h4 class="nav-title-center">E-TICKETS</h4>
            <div class="nav-text-center">
              <i class="icon-e_ticket vtd-icon-7" />
            </div>
          </div>
          <AirlineTicket ref="AirlineTicketRef" />
          <div class="vtd-card-footer nav-text-center d-none d-lg-block">
            <p class="vtd-home-btn text-center">View Now</p>
          </div>
        </div>
      </b-col>

      <b-col class="column-border col-lg card-col col-12">
        <div
          class="vtd-card vtd-animate-shake"
          @click="openTravelInsuranceModal"
          @mouseenter="hasHovered = true"
          @mouseleave="hasHovered = false"
        >
          <div class="navigation-block">
            <h4 class="nav-title-center">TRAVEL INSURANCE</h4>
            <div class="nav-text-center">
              <i class="icon-travel_insurance_light vtd-icon-7" />
            </div>
          </div>
          <Insurance ref="Insurance" />
          <div class="vtd-card-footer nav-text-center d-none d-lg-block">
            <p class="vtd-home-btn text-center">View Now</p>
          </div>
        </div>
      </b-col>

      <b-col
        v-if="
          getBookingInfo &&
          getBookingInfo.secureAdhocs === 'true' &&
          fil === 'M'
        "
        class="column-border col-lg card-col col-12"
      >
        <div @click="openSecureDocsModal" class="vtd-card vtd-animate-shake">
          <div class="navigation-block">
            <h4 class="nav-title-center">DOCUMENTS REQUIRED</h4>
            <div class="nav-text-center">
              <i class="material-icons vtd-icon-7">description</i>
            </div>
          </div>
          <Visa ref="VisaRef" />
          <div class="vtd-card-footer nav-text-center d-none d-lg-block">
            <p class="vtd-home-btn text-center">View Now</p>
          </div>
        </div>
      </b-col>

      <b-col class="column-border col-lg card-col col-12">
        <div @click="openVisaModal" class="vtd-card vtd-animate-shake">
          <div class="navigation-block">
            <h4 class="nav-title-center">ENTRY REQUIREMENTS</h4>
            <div class="nav-text-center">
              <i class="icon-prerequisite vtd-icon-7" />
            </div>
          </div>
          <Visa ref="VisaRef" />
          <div class="vtd-card-footer nav-text-center d-none d-lg-block">
            <p class="vtd-home-btn text-center">View Now</p>
          </div>
        </div>
      </b-col>
    </b-row>
    <HomeBackBtns />
    <SecureDocs ref="SecureDocsRef" info="adhoc" />
  </HomeLayout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import HomeLayout from '@/partials/home-layout'
import AirlineTicket from '@/modules/menu-bar/essential-info/airline-etickets'
import Visa from '@/modules/menu-bar/essential-info/visa'
import Insurance from '@/modules/navigation/modals/insurance'
import VoucherAndDocsModal from '@/modules/navigation/modals/vouchers-documents'
import SecureDocs from '@/partials/extra-info-buttons/secure-docs'

export default {
  components: {
    HomeLayout,
    AirlineTicket,
    Visa,
    Insurance,
    VoucherAndDocsModal,
    SecureDocs,
  },
  data() {
    return {
      loginRes: {},
      hasHovered: false,
    };
  },
  async mounted() {
    if (this.$route.name === 'vouchersAuth') {
      this.loginRes = await this.loginOnStart({
        username: this.$route.params.surname,
        bookingNumber: this.$route.params.bookingNumber,
        source: this.$route.params.source,
      })
    }
    if (!this.loginRes) {
      this.$router.push('/login')
    }
  },
  updated() {
    this.stopLoading()
  },
  computed: {
    ...mapGetters({
      essentialInfoMenu: 'essentialInfoMenu/getMenu',
      fil: 'booking/getFil',
      getBookingInfo: 'booking/getBookingInfo',
    }),
  },
  methods: {
    ...mapActions({
      loginOnStart: 'auth/loginBookingNumberOnStartAction',
    }),
    openPassportModal() {
      for (const [index, item] of this.essentialInfoMenu.entries()) {
        if (item.partial === 'VisaRef') {
          this.$refs.PassportRef.showModal(this.essentialInfoMenu[index])
          this.$root.$on('visaadvice', () => {
            this.$refs.PassportRef.showModal(this.essentialInfoMenu[index])
          })
        }
      }
    },
    openVisaModal() {
      for (const [index, item] of this.essentialInfoMenu.entries()) {
        if (item.partial === 'VisaRef') {
          this.$refs.VisaRef.showModal(this.essentialInfoMenu[index])
          this.$root.$on('visaadvice', () => {
            this.$refs.VisaRef.showModal(this.essentialInfoMenu[index])
          })
        }
      }
    },
    openSecureDocsModal() {
      this.$refs.SecureDocsRef.show()
    },
    openETicketsModal() {
      this.$refs['AirlineTicketRef'].showModal({
        partial: 'AirlineTicketRef',
        title: 'Airline E-Ticket Numbers',
      })
    },
    openTravelInsuranceModal() {
      for (const [index, item] of this.essentialInfoMenu.entries()) {
        if (item.title === 'Travel Insurance') {
          this.$refs.Insurance.showModal(this.essentialInfoMenu[index])
        }
      }
    },
    openVouchersAndDocsModal() {
      for (const [index, item] of this.essentialInfoMenu.entries()) {
        if (item.title === 'Documents') {
          this.$refs.VoucherAndDocRef.showModal(this.essentialInfoMenu[index])
        }
      }
    },
    stopLoading() {
      this.$emit('loading-bar', false)
    },
  },
}
</script>
